var render = function render(){
  var _vm$chemContainers;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chemtracker-module",
    attrs: {
      "id": "chemical-containers",
      "data-test": "outside-vif"
    }
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('RAFTFullScreenContent', {
    attrs: {
      "header-text": "Chemical Containers"
    },
    on: {
      "openClose": _vm.updateOpenClosedFullscreen
    },
    scopedSlots: _vm._u([{
      key: "pager",
      fn: function () {
        return [_c('div', {
          staticClass: "view-pager-total",
          attrs: {
            "role": "status",
            "aria-live": "polite"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.displayAtoB) + "\n        "), _c('strong', [_vm._v(_vm._s(_vm.totalContainers))]), _vm._v(" results\n      ")])];
      },
      proxy: true
    }, {
      key: "topleft",
      fn: function () {
        return [_c('VActionButton', {
          attrs: {
            "show-badge": false,
            "show-icon": false,
            "label": "Download"
          },
          on: {
            "click": _vm.postToCsvDownload
          }
        }, [!_vm.dromoEnabled ? _c('img', {
          attrs: {
            "id": "csv-export-help",
            "src": _vm.helpSrc,
            "alt": "help"
          }
        }) : _vm._e()]), _vm._v(" "), _c('b-popover', {
          attrs: {
            "target": "csv-export-help",
            "triggers": "hover focus"
          }
        }, [_c('template', {
          slot: "title"
        }, [_vm._v(" Data Export")]), _vm._v("\n        This export is only for use of data outside of the system. Any changes\n        to chemical inventory should be made directly here.\n      ")], 2), _vm._v(" "), _vm.showDromoButton ? _c('DromoImportButton') : _vm._e()];
      },
      proxy: true
    }, {
      key: "topright",
      fn: function () {
        return [_c('VActionButton', {
          attrs: {
            "show-badge": true,
            "show-icon": false,
            "label": "Filters",
            "is-pressed": _vm.showFilters,
            "count": _vm.adjustedFilterCount
          },
          on: {
            "click": _vm.toggleShowFilters
          }
        }), _vm._v(" "), _c('VActionButton', {
          attrs: {
            "show-badge": false,
            "show-icon": false,
            "label": "Settings",
            "is-pressed": _vm.showSettings
          },
          on: {
            "click": _vm.toggleShowSettings
          }
        })];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm.showSettings ? _c('div', {
    staticStyle: {
      "font-size": "1rem",
      "color": "var(--blue-900, #2964d4)",
      "font-weight": "500",
      "padding": "0.75rem",
      "margin": "0.5rem 0",
      "background": "#e3f1fe",
      "border-radius": "2px",
      "display": "flex",
      "align-items": "center",
      "gap": "0.25rem"
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": _vm.infoSrc,
      "alt": "info"
    }
  }), _vm._v(" You can uncheck columns to hide\n        them, and drag to rearrange.\n        "), _vm.changesMade ? void 0 : _vm._e()], 2), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "data-test": "reset-defaults"
    },
    on: {
      "click": _vm.resetDefaults
    }
  }, [_vm._v("Reset Defaults")])]) : _vm._e(), _vm._v(" "), _vm.showFilters ? _c('VFilterGroup', {
    attrs: {
      "show-submit": false
    },
    on: {
      "clear-filters": _vm.clearFilters
    },
    scopedSlots: _vm._u([{
      key: "filters",
      fn: function () {
        return [_c('short-text-filter', {
          staticClass: "chemtracker-container-text-filter",
          attrs: {
            "id": "chemical-name",
            "data-test": "chemical-name",
            "label": "Chemical Name",
            "store-watch": "getChemicalNameFilter",
            "path": "field_chemical_name_preferred",
            "filter-key": "chemicalNameFilter",
            "filter-action": "updateFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('short-text-filter', {
          staticClass: "chemtracker-container-text-filter",
          attrs: {
            "id": "cas-num",
            "data-test": "cas-num",
            "store-watch": "getCasNumberFilter",
            "path": "field_chemical_type.field_chemdb_cas_number",
            "label": "CAS Number",
            "filter-key": "casNumberFilter",
            "filter-action": "updateFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('short-text-filter', {
          staticClass: "chemtracker-container-text-filter",
          attrs: {
            "id": "chem-syn-fil",
            "data-test": "chem-syn-fil",
            "label": "Chemical Synonym",
            "store-watch": "getChemicalSynonymFilter",
            "path": "field_chemical_type.field_chemdb_synonyms",
            "store-commit": "setChemicalSynonymFilter",
            "filter-key": "chemicalSynonymFilter",
            "filter-action": "updateChemicalSynonymFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _vm.getLabCheck ? _c('multi-select-filter', {
          attrs: {
            "get-value": _vm.allLabs,
            "id": "lab-fil",
            "data-test": "lab-fil",
            "label": "Group Name",
            "display-value": "title",
            "active-status": "operative_status",
            "track-by": "nid",
            "store-watch": "getSelectedLabsFilter",
            "path": "og_audience.drupal_internal__nid",
            "operator": "IN",
            "filter-key": "selectedLabs",
            "filter-action": "updateMultivalueFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }) : _vm._e(), _vm._v(" "), _vm.getBuildingCheck ? _c('multi-select-filter', {
          attrs: {
            "get-value": _vm.allBuildings,
            "id": "building-fil",
            "data-test": "building-fil",
            "label": "Building",
            "store-watch": "getSelectedBuildingsFilter",
            "display-value": "title",
            "track-by": "nid",
            "path": "field_chemical_space.field_parent_location.drupal_internal__nid",
            "filter-key": "selectedBuildings",
            "filter-action": "updateSelectedBuildings"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }) : _vm._e(), _vm._v(" "), _vm.getSpaceCheck ? _c('multi-select-filter', {
          attrs: {
            "get-value": _vm.allSpaces,
            "id": "space-fil",
            "data-test": "space-fil",
            "label": "Spaces",
            "display-value": "title",
            "store-watch": "getSelectedSpacesFilter",
            "path": "field_chemical_space.drupal_internal__nid",
            "track-by": "drupal_internal__nid",
            "disable": _vm.getSpaceFilterDisabled,
            "filter-key": "selectedSpaces",
            "filter-action": "updateMultivalueFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "advanced-filters",
      fn: function () {
        return [_c('multi-select-filter', {
          attrs: {
            "get-value": _vm.getChemOwningUserOptions,
            "id": "chem-owner-fil",
            "hovertip": _vm.chemicalOwnerHovertip,
            "data-test": "chem-owner-fil",
            "label": "Chemical Owner",
            "display-value": "field_prof_display_name_value",
            "store-watch": "getSelectedChemOwningUsers",
            "path": "field_chemical_container_owner.meta.drupal_internal__target_id",
            "operator": "IN",
            "track-by": "uid",
            "filter-key": "selectedChemicalOwningUsers",
            "filter-action": "updateMultivalueFilter",
            "options-limit": _vm.chemicalOwnerOptionsLimit
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('multi-select-filter', {
          attrs: {
            "get-value": _vm.physicalStates,
            "id": "state-fil",
            "data-test": "state-fil",
            "label": "Physical State",
            "display-value": "label",
            "store-watch": "getSelectedPhysicalStatesFilter",
            "path": "field_chemical_type.field_chemdb_physical_state",
            "operator": "IN",
            "track-by": "key",
            "filter-key": "selectedPhysicalStates",
            "filter-action": "updateMultivalueFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _vm.getBuildingCheck ? _c('multi-select-filter', {
          attrs: {
            "get-value": _vm.allDepartments,
            "id": "dept-fil",
            "data-test": "dept-fil",
            "label": "Department/Unit",
            "display-value": "title",
            "track-by": "nid",
            "store-watch": "getSelectedDepartmentsFilter",
            "path": "og_audience.og_audience.drupal_internal__nid",
            "operator": "IN",
            "filter-key": "selectedDepartments",
            "filter-action": "updateMultivalueFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }) : _vm._e(), _vm._v(" "), _vm.getBuildingCheck ? _c('multi-select-filter', {
          attrs: {
            "get-value": _vm.allCampuses,
            "hide-empty": true,
            "id": "campus-fil",
            "data-test": "campus-fil",
            "label": "Site/Campus",
            "display-value": "title",
            "track-by": "nid",
            "store-watch": "getSelectedCampusesFilter",
            "path": "field_chemical_space.field_parent_location.field_parent_location.drupal_internal__nid",
            "filter-key": "selectedCampuses",
            "filter-action": "updateMultivalueFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('date-filter', {
          attrs: {
            "wrapper-class": "update-after-filter",
            "get-value": _vm.getUpdatedAfterDateFilter,
            "id": "last-update-after-fil",
            "data-test": "last-update-after-fil",
            "placeholder": "",
            "label": "Last Updated After",
            "hovertip": _vm.lastUpdateAfterHovertip,
            "input-class": "chemtracker-container-date-filter",
            "filter-key": "updateAfterDateFilter",
            "filter-action": "updateUpdatedAfterDateFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('date-filter', {
          attrs: {
            "get-value": _vm.getUpdatedBeforeDateFilter,
            "update-method": _vm.updateUpdatedBeforeDateFilter,
            "id": "last-update-before-fil",
            "data-test": "last-update-before-fil",
            "placeholder": "",
            "name": "Last Updated Before",
            "label": "Last Updated Before",
            "input-class": "chemtracker-container-date-filter",
            "filter-key": "updateBeforeDateFilter",
            "filter-action": "updateUpdatedBeforeDateFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('short-text-filter', {
          staticClass: "chemtracker-container-text-filter",
          attrs: {
            "id": "product-filter",
            "data-test": "product-filter",
            "name": "product-filter",
            "label": "Product Name",
            "store-watch": "getChemicalProductFilter",
            "path": "field_chemical_product_name",
            "filter-key": "chemicalProductFilter",
            "filter-action": "updateFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('date-filter', {
          attrs: {
            "get-value": _vm.getContainerExpiresAfterFilter,
            "id": "container-expires-after-fil",
            "data-test": "container-expires-after-fil",
            "name": "container-expires-after-fil",
            "placeholder": "",
            "label": "Container Expires After",
            "input-class": "chemtracker-container-date-filter",
            "filter-key": "containerExpiresAfterDateFilter",
            "filter-action": "updateContainerExpiresAfterFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('date-filter', {
          attrs: {
            "get-value": _vm.getContainerExpiresBeforeFilter,
            "id": "container-expires-before-fil",
            "data-test": "container-expires-before-fil",
            "name": "container-expires-before-fil",
            "placeholder": "",
            "label": "Container Expires Before",
            "input-class": "chemtracker-container-date-filter",
            "filter-key": "containerExpiresBeforeDateFilter",
            "filter-action": "updateContainerExpiresBeforeFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('multi-select-filter', {
          attrs: {
            "get-value": _vm.allChemicalHazards,
            "id": "hazard-code-fil",
            "data-test": "hazard-code-fil",
            "label": "Chemical Hazards",
            "display-value": "label",
            "track-by": "key",
            "store-watch": "getSelectedHazardCodesFilter",
            "store-commit": "setSelectedHazardCodesFilter",
            "path": "field_chemical_type.field_chemdb_hazard_code",
            "operator": "IN",
            "filter-key": "selectedHazardCodes",
            "filter-action": "updateMultivalueFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('multi-select-filter', {
          attrs: {
            "get-value": _vm.dataBaseLinkageStatuses,
            "id": "database-link-fil",
            "data-test": "database-link-fil",
            "label": "Database Linkage Status",
            "display-value": "label",
            "track-by": "key",
            "multiple": false,
            "store-watch": "getSelectedDatabaseLinkageFilter",
            "hovertip": _vm.databaseLinkageStatusHovertip,
            "wrapper-class": "chemical-database-linkage-filter",
            "filter-key": "selectedDatabaseLinkage",
            "filter-action": "updateSelectedDatabaseLinkageFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('multi-select-filter', {
          attrs: {
            "get-value": _vm.storageGroups,
            "id": "storage-group-fil",
            "data-test": "storage-group-fil",
            "label": "Storage Group",
            "display-value": "label",
            "track-by": "key",
            "multiple": true,
            "store-watch": "getSelectedStorageGroupFilter",
            "path": "field_chemical_type.field_chemdb_storage_group",
            "filter-key": "selectedStorageGroup",
            "filter-action": "updateMultivalueFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('short-text-filter', {
          staticClass: "chemtracker-container-text-filter",
          attrs: {
            "id": "bench-fil",
            "data-test": "bench-fil",
            "label": "Bench",
            "store-watch": "getBenchFilter",
            "path": "field_chemical_bench_location",
            "filter-key": "benchFilter",
            "filter-action": "updateFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('short-text-filter', {
          staticClass: "chemtracker-container-text-filter",
          attrs: {
            "id": "shelf-fil",
            "data-test": "shelf-fil",
            "label": "Shelf",
            "store-watch": "getShelfFilter",
            "path": "field_chemical_shelf_location",
            "filter-key": "shelfFilter",
            "filter-action": "updateFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('short-text-filter', {
          staticClass: "chemtracker-container-text-filter",
          attrs: {
            "id": "sln-fil",
            "data-test": "sln-fil",
            "label": "Specific Location Note",
            "store-watch": "getSpecificLocationNoteFilter",
            "path": "field_chemical_room_location",
            "filter-key": "specificLocationNoteFilter",
            "filter-action": "updateFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _vm.sds_enabled ? [_c('multi-select-filter', {
          attrs: {
            "get-value": _vm.sdsOriginStatuses,
            "id": "sds-origin-fil",
            "data-test": "sds-origin-fil",
            "label": "SDS Origin",
            "display-value": "label",
            "track-by": "key",
            "multiple": false,
            "store-watch": "getSdsOriginFilter",
            "wrapper-class": "chemical-sds-origin-filter",
            "filter-key": "sdsOriginFilter",
            "filter-action": "updateSdsOriginFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('date-filter', {
          attrs: {
            "get-value": _vm.getSdsDocumentDateAfterFilter,
            "id": "sds-document-after-fil",
            "data-test": "sds-document-after-fil",
            "name": "sds-document-after-fil",
            "placeholder": "",
            "label": "SDS Document Date After",
            "input-class": "chemtracker-container-date-filter",
            "filter-key": "sdsDocumentDateAfterFilter",
            "filter-action": "updateSdsDocumentDateAfterFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('date-filter', {
          attrs: {
            "get-value": _vm.getSdsDocumentDateBeforeFilter,
            "id": "sds-document-before-fil",
            "data-test": "sds-document-before-fil",
            "name": "sds-document-before-fil",
            "placeholder": "",
            "label": "SDS Document Date Before",
            "input-class": "chemtracker-container-date-filter",
            "filter-key": "sdsDocumentDateBeforeFilter",
            "filter-action": "updateSdsDocumentDateBeforeFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        })] : _vm._e(), _vm._v(" "), _c('toggle-filter', {
          attrs: {
            "get-value": _vm.getShowControlledSubstancesFilter,
            "id": "controlled-substances-fil",
            "data-test": "controlled-substances-fil",
            "label": "Controlled Substance",
            "filter-key": "showControlledSubstances",
            "filter-action": "updateShowControlledSubstancesFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('toggle-filter', {
          attrs: {
            "get-value": _vm.getShowDeletedContainersFilter,
            "id": "deleted-containers",
            "data-test": "deleted-containers",
            "label": "Only Removed Containers",
            "filter-key": "showDeletedContainers",
            "filter-action": "updateShowDeletedContainersFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('short-text-filter', {
          staticClass: "chemtracker-container-text-filter",
          attrs: {
            "id": "notes-fil",
            "data-test": "notes-fil",
            "label": "Notes",
            "store-watch": "getNotesFilter",
            "path": "field_chemical_note.value",
            "filter-key": "notesFilter",
            "filter-action": "updateFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _c('multi-select-filter', {
          attrs: {
            "get-value": _vm.expiredStatuses,
            "id": "expired-status-fil",
            "data-test": "expired-status-fil",
            "label": "Expired Status",
            "display-value": "label",
            "track-by": "key",
            "multiple": false,
            "hovertip": _vm.expiredStatusHovertip,
            "store-watch": "getSelectedExpiredStatusFilter",
            "store-commit": "setSelectedExpiredStatusFilter",
            "filter-key": "selectedExpiredStatus",
            "filter-action": "updateSelectedExpiredStatusFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }), _vm._v(" "), _vm.dromoEnabled ? _c('long-text-filter', {
          attrs: {
            "label": "Import ID",
            "id": "imp-id-fil",
            "data-test": "imp-id-fil",
            "use-short-text": true,
            "get-value": _vm.getImportIdFilter,
            "store-watch": "getImportIdFilter",
            "filter-key": "selectedImportId",
            "filter-action": "updateImportIdFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('long-text-filter', {
          attrs: {
            "get-value": _vm.getContainerIDsFilter,
            "id": "con-ids-fil",
            "data-test": "con-ids-fil",
            "placeholder": "Comma-delimited (or one per line) list of Container IDs",
            "store-watch": "getContainerIDsFilter",
            "label": "Container IDs",
            "filter-key": "containerIDsFilter",
            "filter-action": "updateContainerIDsFilter"
          },
          on: {
            "update-filter": function ($e) {
              return _vm.debouncedDispatchFilter($e);
            }
          }
        })];
      },
      proxy: true
    }], null, false, 806093711)
  }) : _vm._e(), _vm._v(" "), _c('b-table', {
    ref: "table",
    class: {
      'table-pause-scroll': _vm.isBusy || ((_vm$chemContainers = _vm.chemContainers) === null || _vm$chemContainers === void 0 ? void 0 : _vm$chemContainers.length) < 1,
      'table-responsive': _vm.responsiveTable,
      'table-fullscreen': !_vm.responsiveTable
    },
    attrs: {
      "striped": "",
      "hover": "",
      "sticky-header": true,
      "no-local-sorting": true,
      "no-sort-reset": true,
      "show-empty": "",
      "busy": _vm.isBusy,
      "fields": _vm.getFields,
      "items": _vm.chemContainers,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "current-page": _vm.currentPage
    },
    on: {
      "sort-changed": _vm.sortingChangedEvent
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center text-danger my-2"
        }, [_vm.$isB4 ? _c('div', [_c('b-spinner'), _vm._v(" "), _c('strong', [_vm._v("Loading...")])], 1) : _c('div', [_c('RaftBusy', {
          attrs: {
            "busy-text": "Loading..."
          }
        })], 1)])];
      },
      proxy: true
    }, {
      key: "empty",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "chemtracker-empty-text"
        }, [_vm._v("\n          " + _vm._s(_vm.emptyStateText) + "\n        ")])];
      }
    }, {
      key: "head()",
      fn: function (data) {
        var _data$field;
        return [_c('div', {
          staticClass: "column-toggle",
          class: {
            dragging: _vm.dragTarget != null
          },
          attrs: {
            "draggable": "true"
          },
          on: {
            "dragenter": function ($event) {
              return _vm.dragEnter($event, data.field.key);
            },
            "dragstart": function ($event) {
              return _vm.dragStart($event, data.field);
            },
            "dragend": function ($event) {
              return _vm.dragEnd($event, data.field.key);
            }
          }
        }, [_vm.showSettings ? _c('input', {
          key: data === null || data === void 0 ? void 0 : (_data$field = data.field) === null || _data$field === void 0 ? void 0 : _data$field.key,
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.isChecked(data.field.key)
          },
          on: {
            "input": function (event) {
              return _vm.handleColumnCheckbox(event, data.field.key);
            }
          }
        }) : _vm._e(), _vm._v("\n          " + _vm._s(data === null || data === void 0 ? void 0 : data.label) + "\n          "), _vm.showSettings ? _c('img', {
          staticClass: "draghandle",
          attrs: {
            "src": _vm.dragSrc,
            "alt": "drag handle"
          }
        }) : _vm._e()])];
      }
    }, _vm.sds_enabled ? {
      key: "cell(field_chemical_sds)",
      fn: function (data) {
        return [_c('div', {
          class: {
            dogged: _vm.checkSdsOutdated(data === null || data === void 0 ? void 0 : data.item)
          }
        }, [_vm._v("\n          " + _vm._s(_vm.formatSdsOrigin(data === null || data === void 0 ? void 0 : data.item)) + "\n        ")])];
      }
    } : null, _vm.sds_enabled && _vm.canEdit ? {
      key: "cell(field_attach_sds)",
      fn: function (data) {
        var _data$item;
        return [_c('a', {
          attrs: {
            "href": "#",
            "rel": 'add-sds-' + (data === null || data === void 0 ? void 0 : data.index),
            "data-test": 'add-sds-' + (data === null || data === void 0 ? void 0 : (_data$item = data.item) === null || _data$item === void 0 ? void 0 : _data$item.field_chemical_container_id)
          },
          on: {
            "click": function ($event) {
              var _data$item2;
              return _vm.showSdsDialog(data === null || data === void 0 ? void 0 : (_data$item2 = data.item) === null || _data$item2 === void 0 ? void 0 : _data$item2.id);
            }
          }
        }, [_vm._v("Add SDS")])];
      }
    } : null, {
      key: "cell(og_audience[0].title)",
      fn: function (data) {
        var _data$item3, _data$item4;
        return [data !== null && data !== void 0 && (_data$item3 = data.item) !== null && _data$item3 !== void 0 && _data$item3.og_audience[0] ? _c('a', {
          attrs: {
            "href": _vm.buildNodeUrl(data.item.og_audience[0].drupal_internal__nid)
          }
        }, [_vm._v("\n          " + _vm._s(data === null || data === void 0 ? void 0 : (_data$item4 = data.item) === null || _data$item4 === void 0 ? void 0 : _data$item4.og_audience[0].title))]) : _vm._e()];
      }
    }, {
      key: "cell(field_chemical_space.title)",
      fn: function (data) {
        var _data$item5;
        return [data !== null && data !== void 0 && (_data$item5 = data.item) !== null && _data$item5 !== void 0 && _data$item5.field_chemical_space ? _c('a', {
          attrs: {
            "href": _vm.buildNodeUrl(data.item.field_chemical_space.drupal_internal__nid)
          }
        }, [_vm._v("\n          " + _vm._s(data.item.field_chemical_space.title))]) : _vm._e()];
      }
    }, {
      key: "cell(field_chemical_container_id)",
      fn: function (data) {
        var _data$item6;
        return [_c('a', {
          attrs: {
            "href": _vm.buildContainerUrl(data === null || data === void 0 ? void 0 : data.item)
          }
        }, [_vm._v(_vm._s(data === null || data === void 0 ? void 0 : (_data$item6 = data.item) === null || _data$item6 === void 0 ? void 0 : _data$item6.field_chemical_container_id))])];
      }
    }, _vm.canEdit ? {
      key: "cell(chemical_container_edit)",
      fn: function (data) {
        return [_c('a', {
          attrs: {
            "href": _vm.buildContainerUrl(data.item, '/edit')
          }
        }, [_vm._v("Edit")])];
      }
    } : null, _vm.getShowDeletedContainersFilter ? {
      key: "cell(chemical_container_remove)",
      fn: function () {
        return [_c('span', {
          attrs: {
            "id": "removedLink"
          }
        }, [_vm._v("Removed")])];
      },
      proxy: true
    } : _vm.canEdit && !_vm.getShowDeletedContainersFilter ? {
      key: "cell(chemical_container_remove)",
      fn: function (data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.removeContainerConfirm(data.item);
            }
          }
        }, [_vm._v("Remove")])];
      }
    } : null, {
      key: "cell(field_chemical_name_preferred)",
      fn: function (data) {
        var _data$item7;
        return [data !== null && data !== void 0 && (_data$item7 = data.item) !== null && _data$item7 !== void 0 && _data$item7.field_chemical_name_preferred ? _c('a', {
          attrs: {
            "href": _vm.buildChemicalTypeUrl(data.item)
          }
        }, [_vm._v(_vm._s(data.item.field_chemical_name_preferred))]) : _vm._e()];
      }
    }, {
      key: "cell(field_chemical_container_owner.field_prof_display_name)",
      fn: function (data) {
        var _data$item8;
        return [data !== null && data !== void 0 && (_data$item8 = data.item) !== null && _data$item8 !== void 0 && _data$item8.field_chemical_container_owner ? _c('a', {
          attrs: {
            "href": _vm.buildUserUrl(data.item.field_chemical_container_owner)
          }
        }, [_vm._v("\n          " + _vm._s(data.item.field_chemical_container_owner.field_prof_display_name))]) : _vm._e()];
      }
    }, {
      key: "cell(field_chemical_note)",
      fn: function (data) {
        var _data$item9;
        return [_vm._v("\n        " + _vm._s(_vm.formatNotes(data === null || data === void 0 ? void 0 : (_data$item9 = data.item) === null || _data$item9 === void 0 ? void 0 : _data$item9.field_chemical_note)) + "\n      ")];
      }
    }, {
      key: "cell(view_attached_sds)",
      fn: function (row) {
        var _row$item, _row$item2, _row$item2$field_chem;
        return [row !== null && row !== void 0 && (_row$item = row.item) !== null && _row$item !== void 0 && _row$item.field_chemical_sds ? _c('span', [_vm.getSdsLink(row.item.field_chemical_sds) !== '' ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": _vm.getSdsLink(row.item.field_chemical_sds)
          }
        }, [_vm._v("View\n          ")]) : (row === null || row === void 0 ? void 0 : (_row$item2 = row.item) === null || _row$item2 === void 0 ? void 0 : (_row$item2$field_chem = _row$item2.field_chemical_sds) === null || _row$item2$field_chem === void 0 ? void 0 : _row$item2$field_chem.type) === 'raft_metadata--sds_external' ? _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              return _vm.ChemtrackerSdsHelper.sdsDownloadFile(row.item.field_chemical_sds.field_sds_provider, row.item.field_chemical_sds.field_sds_document_id);
            }
          }
        }, [_vm._v("View\n          ")]) : _vm._e()]) : _vm._e()];
      }
    }, {
      key: "cell(field_chemical_expiration)",
      fn: function (data) {
        var _data$item0;
        return [_vm._v("\n        " + _vm._s(data === null || data === void 0 ? void 0 : (_data$item0 = data.item) === null || _data$item0 === void 0 ? void 0 : _data$item0.field_chemical_expiration) + "\n      ")];
      }
    }, {
      key: "cell(field_chemical_expired_status)",
      fn: function (data) {
        var _data$item1;
        return [_vm._v(_vm._s(_vm.getExpiredStatus(data === null || data === void 0 ? void 0 : (_data$item1 = data.item) === null || _data$item1 === void 0 ? void 0 : _data$item1.field_chemical_expiration)))];
      }
    }], null, true)
  }), _vm._v(" "), !_vm.isBusy ? _c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalContainers,
      "per-page": _vm.containersPerPage,
      "aria-controls": "my-table",
      "limit": "10",
      "first-text": "« first",
      "prev-text": "‹ previous",
      "next-text": "next ›",
      "last-text": "last »",
      "align": "center"
    },
    on: {
      "change": _vm.handlePageChange
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog'), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "chem-container-sds-attach",
      "title": _vm.getSdsModalTitle,
      "size": "xl",
      "scrollable": "",
      "centered": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "cancel-disabled": "",
      "ok-disabled": "",
      "no-stacking": ""
    },
    on: {
      "close-sds-dialog": _vm.hideSdsDialog
    }
  }, [_c('ChemicalContainerSdsAttachments', {
    attrs: {
      "selected-container-uuid": _vm.sdsSelectedContainerUuid
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }